import { z } from '@betty/toolkit/api';

export const UploadKYCDocsSchema = z.object({}).optional();
